import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {EmailFormComponent} from "../email-form/email-form.component";
import {ModalOptions} from "ngx-bootstrap/modal";

@Component({
    selector: 'app-note-registration',
    exportAs: 'ngModel',
    templateUrl: './note-registration.component.html',
    styleUrls: ['./note-registration.component.scss']
})
export class NoteRegistrationComponent implements AfterViewInit {

    _config: NotificationConfig
    form: FormGroup
    notify: boolean = false
    @ViewChild(EmailFormComponent)
    emailForm: EmailFormComponent

    constructor(private fb: FormBuilder, public options: ModalOptions) {
        this.form = this.fb.group(
            {
                note: ['', [Validators.required]]
            }
        );
    }

    ngAfterViewInit(): void {
        console.log('' + this.emailForm)
        this.emailForm.to = this._config?.to
        this.emailForm.bcc = this._config?.bcc
    }

    onNotify() {
        this.notify = !this.notify;
    }

    get noteRequired(): boolean {
        return this.getRequiredErrors('note')
    }

    private getRequiredErrors(field: string) {
        return this.form.get(field)?.errors?.['required']
    }

    public get valid() {
        const valid = this.form.valid && (!this.notify || (this.emailForm && this.emailForm.emailForm.valid))
        return valid
    }

    public get data() {
        return {
            note: this.form.value.note,
            notify: this.notify,
            email: this.emailForm.email
        }
    }

    set config(config: NotificationConfig) {
        this._config = config
    }
}

export interface NotificationConfig {
    to?: string
    bcc?: string
}
